module.exports = __webpack_public_path__ + "img/fatt_autom_invoiceweb.25e800bc.png";